import { getCurrentInstance, computed, reactive } from 'vue';
import { ModuleStatistic } from '@/stores/moduleConst';
import { useStore } from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCacheStatisticComboConfig = () => {
  const { proxy } = getCurrentInstance();

  const store = useStore();

  const statisticCombo = computed(() => {
    const statistics = store.getters[`${ModuleStatistic}/items`];
    return statistics.filter(x => !x.inactive);
  });

  // config columns combo
  const cacheStatisticComboConfig = reactive({
    data: statisticCombo,
    columns: [
      {
        title: 'Mã thống kê',
        dataField: 'statistic_code',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên thống kê',
        dataField: 'statistic_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'statistic_code',
    valueField: 'statistic_id',
    queryMode: 'local',
    dropdownWidth: 600,
    quickSearch: 'LocalQuickSearchPopup',
    quickSearchParam: {
      idField: 'statistic_id',
      titleSearch: 'Tìm nhanh thống kê',
    },
  });

  return {
    cacheStatisticComboConfig,
  };
};
